module.exports = __webpack_public_path__ + "img/logo-served.5954aaa0.png";